import React, { useState, useEffect } from "react";
import { FaEllipsisV } from "react-icons/fa";
import styles from "./Episode.module.css";
import AuthContext from "../../contexts/AuthContext";
import cogoToast from "cogo-toast";

const EpisodeComments = ({ episodeID }) => {
  const [newComment, setNewComment] = useState("");
  const { token } = React.useContext(AuthContext);

  const [comments, setComments] = useState([]);

  const fetchComments = async () => {
    const rawResponse = await fetch(
      `https://api.yazbie.com/api/comments?episodeId=${episodeID}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    try {
      let content = await rawResponse.clone().json();
      console.log(content);
      if (content && content.success) {
        setComments(content.comments);
      } else if (content && !content.success) {
        cogoToast.error(content.message);
      }
    } catch (err) {
      console.log(err);
      console.log(await rawResponse.clone().text());
      cogoToast.error(await rawResponse.clone().text());
      return false;
    }
  };

  useEffect(() => {
    fetchComments();
  }, []);

  const submitComment = async (e) => {
    setNewComment("");
    try {
      const rawResponse = await fetch(
        `https://api.yazbie.com/api/comments/create`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            comment_body: newComment,
            episodeId: episodeID,
          }),
        }
      );
      try {
        const content = await rawResponse.json();
        if (content && content.success) {
          cogoToast.success(content.message);
          fetchComments();
        } else if (content && !content.success) {
          cogoToast.error(content.message);
        }
      } catch (e) {
        console.log(e);
        cogoToast.error("Something went wrong");
      }
    } catch (e) {
      console.log(e);
      cogoToast.error("Something went wrong");
    }
  };

  return (
    <div className={styles.comments}>
      <div className={styles.commentsInput}>
        <input
          type="text"
          placeholder="Add a comment"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          // onKeyDown={submitComment}
        />
        <button onClick={submitComment}>Add</button>
      </div>
      {comments.map((comment) => (
        <Comment comment={comment} key={comment._id} />
      ))}
    </div>
  );
};

export default EpisodeComments;

const Comment = ({ comment }) => {
  return (
    <div className={styles.comment}>
      <div className={styles.user}>
        <div
          className={styles.avatar}
          style={{
            backgroundImage: `url(${comment.postedBy.avatar_link ?? 'https://images.unsplash.com/photo-1593153014720-2655782328c9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80'})`,
          }}
        />
        <div>{comment.postedBy.name}</div>
      </div>

      <div className={styles.text}>{comment.comment_body}</div>
      <div className={styles.actionsButton}>
        <FaEllipsisV />
      </div>
    </div>
  );
};
